import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { UpdateQuotationClientResponse } from '../@types/UpdateQuotation'

type Store = {
  updateQuotation: UpdateQuotationClientResponse | null
  setUpdateQuotation: (value: UpdateQuotationClientResponse) => void
}

export const useUpdateQuotationStore = create<Store>()(
  devtools(
    (set) => ({
      updateQuotation: null,
      setUpdateQuotation: (updateQuotation) => set({ updateQuotation }),
    }),
    { name: 'UpdateQuotationStore' },
  ),
)
